// import Vue from 'vue'
// const $t = Vue.prototype.$t
export const tabPaneArr = [
  {
    name: 'payroll_wage_15',
    title: 'step1',
    comp: () => import('./step1.vue'),
    data: {
      info: {}
    },
    id: 1 // 考勤设置
  },
  {
    name: 'payroll_wage_17',
    title: 'step2',
    comp: () => import('./step2'),
    data: {
      info: {},
      state: '' // 当前子项目状态
    },
    id: 2 // 工资设置
  },
  {
    name: 'payroll_wage_18',
    title: 'step2',
    comp: () => import('./step3'),
    data: {
      info: {},
      state: '' // 当前子项目状态
    },
    id: 3 // 工资设置
  }
]
export const tabData = {
  info: {},
  state: '', // 当前子项目状态
  is_self_task: '' // 是否本人操作
}
